import React from 'react'

const CircleIcon = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  const { children, ...rest } = props
  return (
    <svg { ...rest } className="svg-icon" fill="none" xmlns="http://www.w3.org/2000/svg">
      {children}
    </svg>
  )
}

const CheckSolidIcon = (): React.JSX.Element => {
  return (
    <CircleIcon viewBox="0 0 14 14">
      <path
        d='M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM10.0898 5.71484L6.58984 9.21484L6.125 9.67969L5.66016 9.21484L3.91016 7.46484L3.44531 7L4.375 6.07305L4.83984 6.53789L6.125 7.82305L9.16016 4.78516L9.625 4.32031L10.552 5.25L10.0871 5.71484H10.0898Z'
        fill={'#3B763D'}/>
    </CircleIcon>
  )
}

const WarningSolidIcon = (): React.JSX.Element => {
  return (
    <CircleIcon viewBox="0 0 14 14">
      <path
        d='M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM7.65625 3.5V4.15625V7.21875V7.875H6.34375V7.21875V4.15625V3.5H7.65625ZM6.34375 10.0625V8.75H7.65625V10.0625H6.34375Z'
        fill={'#E16642'}/>
    </CircleIcon>
  )
}

const CheckHollowIcon = () : React.JSX.Element => {
  return (
    <CircleIcon viewBox="0 0 15 15">
      <g clipPath={'url(#clip0_8279_2160)'}>
        <path
          d='M7.48931 14.4647C9.33217 14.4647 11.1107 13.7254 12.4179 12.429C13.725 11.1218 14.4536 9.35399 14.4536 7.50042C14.4536 5.64685 13.7143 3.87899 12.4179 2.57185C11.1107 1.2647 9.34288 0.536133 7.48931 0.536133C5.63574 0.536133 3.86788 1.27542 2.56074 2.57185C1.26431 3.87899 0.525024 5.65756 0.525024 7.50042C0.525024 9.34328 1.26431 11.1218 2.56074 12.429C3.86788 13.7361 5.63574 14.4647 7.48931 14.4647Z'
          fill={'#FFFFFF'} stroke={'#3B763D'} strokeMiterlimit={'10'}/>
        <path
          d='M11.2821 6.51465L7.53213 10.2646L7.03928 10.7575L6.5357 10.2646L4.6607 8.38965L4.16785 7.88608L5.16428 6.88965L5.65713 7.39322L7.03928 8.76465L10.2857 5.51822L10.7893 5.01465L11.7857 6.01108L11.2821 6.51465Z'
          fill={'#3B763D'}/>
      </g>
      <defs>
        <clipPath id="clip0_8279_2160">
          <rect width="15" height="15" fill={'#FFFFFF'} />
        </clipPath>
      </defs>
    </CircleIcon>
  )
}

const CheckCircleIcon = (): React.JSX.Element => {
  // source: https://icons.getbootstrap.com/icons/check-circle-fill/
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
         className="svg-icon"
         viewBox="0 0 16 16">
      <path
        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384
        7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
      />
    </svg>
  )
}

const GreenSolidExclamationIcon = (): React.JSX.Element => {
  // https://fontawesome.com/icons/classic/solid/exclamation-circle
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM7.65625 3.5V4.15625V7.21875V7.875H6.34375V7.21875V4.15625V3.5H7.65625ZM6.34375 10.0625V8.75H7.65625V10.0625H6.34375Z"
        fill={'#3B763D'}/>
    </svg>
  )
}

const RedSolidExclamationIcon = (): React.JSX.Element => {
  // https://fontawesome.com/icons/classic/solid/exclamation-circle
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM7.65625 3.5V4.15625V7.21875V7.875H6.34375V7.21875V4.15625V3.5H7.65625ZM6.34375 10.0625V8.75H7.65625V10.0625H6.34375Z"
        fill={'#652410'}/>
    </svg>
  )
}

const EDInfoIcon = (): React.JSX.Element => {
  return (
    <CircleIcon viewBox="0 0 14 14">
      <path
        d='M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM7.65625 3.5V4.15625V7.21875V7.875H6.34375V7.21875V4.15625V3.5H7.65625ZM6.34375 10.0625V8.75H7.65625V10.0625H6.34375Z'
        fill="currentColor"
      />
    </CircleIcon>
  )
}

export {
  CheckSolidIcon,
  WarningSolidIcon,
  CheckHollowIcon,
  CheckCircleIcon,
  GreenSolidExclamationIcon,
  RedSolidExclamationIcon,
  EDInfoIcon,
}
